import { BallotReadyRepresentativeMap } from '../types/ballot-ready-types'
import { fetchNetlify } from './netlify'

export const fetchBallotReadyRepresentatives = async (address: string) =>
  await fetchNetlify<BallotReadyRepresentativeMap>(
    `/.netlify/functions/ballot-ready-representatives?address=${address}`
  )
